const Footer = () => {
    return (
        <footer className="footer mt-auto py-4 bg-dark">
            <div className="container">
                <p className="text-light ">App desenvolvido por <a className="link-name text-decoration-none" href="https://github.com/rafaelofficial" target="_blank" rel="noreferrer"><em>Rafael Sousa Pereira</em></a></p>
                <p className="text-light text-decoration-none"><small><strong>Semana Spring React</strong><br />
      Evento promovido pela escola DevSuperior: <a className="link-name text-decoration-none " href="https://instagram.com/devsuperior.ig" target="_blank" rel="noreferrer"><em>@devsuperior.ig</em></a></small></p>
            </div>
        </footer>
    );
}

export default Footer;
